
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialModule } from '@app/src/material.module';
import { RunnerDetailsDialogComponent } from '@app/shared/components/argument-card/runner-details-dialog/runner-details-dialog.component';
import { ConfigArgumentsCardComponent } from '@app/shared/components/config-arguments-card/config-arguments-card.component';
import { ConfigExpandedComponent } from '@app/shared/components/config-expanded/config-expanded.component';
import { ConfirmDialogComponent } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { DropdownComponent } from '@app/shared/components/dropdown/dropdown.component';
import { DurationShowComponent } from '@app/shared/components/duration-show/duration-show.component';
import { FeatureWorkflowExpandComponent } from '@app/shared/components/feature-workflow-expand/feature-workflow-expand.component';
import { MatChipComponent } from '@app/shared/components/mat-chip/mat-chip.component';
import { MatCardComponent } from './components/mat-card/mat-card.component';
import { QualityGatesFeWfComponent } from '@app/shared/components/quality-gates-fe-wf/quality-gates-fe-wf.component';
import { PriorityDialogComponent } from '@app/shared/components/que-mnger-expand-config/priority-dialog/priority-dialog.component';
import { QueMngerExpandConfigComponent } from '@app/shared/components/que-mnger-expand-config/que-mnger-expand-config.component';
import { TableExpandableEditableComponent } from '@app/shared/components/table-expandable-editable/table-expandable-editable.component';
import { TableExpandableComponent } from '@app/shared/components/table-expandable/table-expandable.component';
import { TableNormalComponent } from '@app/shared/components/table-normal/table-normal.component';
import { TmViewWfRowComponent } from '@app/shared/components/tm-view-wf-row/tm-view-wf-row.component';
import { TypeSpecificStatusComponent } from '@app/shared/components/type-specific-status/type-specific-status.component';
import { WorkflowRunOverviewComponent } from '@app/shared/components/workflow-run-overview/workflow-run-overview.component';
import { ElevationDirective } from '@app/shared/directives/elevation.directive';
import { GridColsDirective } from '@app/shared/directives/grid-cols.directive';
import { StatusDirective } from '@app/shared/directives/status.directive';
import { ChartsModule } from '@app/shared/module/charts/charts.module';
import { ViewToolComponent } from '@app/modules/tools/components/view-tool/view-tool.component';
import { CommonTableWithEditComponent } from '@app/shared/components/common-table-with-edit/common-table-with-edit.component';
import { InputAndArgumentsComponent } from '@app/shared/components/config-builder-components/input-and-arguments/input-and-arguments.component';
import { TriggerAndArtifactComponent } from '@app/shared/components/config-builder-components/trigger-and-artifact/trigger-and-artifact.component';
import { WorkflowConfigComponent } from '@app/shared/components/config-builder-components/workflow-config/workflow-config.component';
import { SchedulerComponent } from '@app/modules/integrated-workflows/scheduler/scheduler.component';
import { SchedulerDialogComponent } from '../modules/integrated-workflows/scheduler-dialog/scheduler-dialog.component';
import { IwAddWfComponent } from '@app/modules/integrated-workflows/iw-add-wf/iw-add-wf.component';
import { VideoComponent } from '@app/shared/components/video/video.component';
import { GuidedTourComponent } from '@app/shared/components/guided-tour/guided-tour.component';
import { GuidedTourModule } from 'ngx-guided-tour';
import { NoDataAvailableComponent } from '@app/shared/components/no-data-available/no-data-available.component';
import { AutoCompleteDropdownComponent } from '@app/shared/components/auto-complete-dropdown/auto-complete-dropdown.component';
import { I18nPipe } from './pipes/i18n.pipe';
import { WorkflowDetailsComponent } from '@app/shared/components/config-builder-components/workflow-details/workflow-details.component';
import { DynamicDropdownComponent } from '@app/shared/components/dynamic-dropdown/dynamic-dropdown/dynamic-dropdown.component';
import { ProfileComponent } from '@app/shared/components/profile/profile.component';
import { DynamicRecursiveMenuComponent } from '@app/shared/components/dynamic-recursive-menu/dynamic-recursive-menu.component';
import { DateTime } from '@app/shared/pipes/dateTime.pipe';
import { ColumnResizeDirective } from './directives/column-resize.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { AutocompletePositionDirective } from './directives/AutocompletePositionDirective';
import { DurationFormatterPipe } from './pipes/timeDuration.pipe';
import { DynamicFormComponent } from './components/dynamic-form-component/dynamic-form.component';
import { InputArgsParentComponent } from './components/config-builder-components/input-args-parent/input-args-parent.component';
import { IssueTmplTableComponent } from './components/config-builder-components/issue-tmpl-table/issue-tmpl-table.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { DependencyGraphComponent } from './components/dependency-graph/dependency-graph.component';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { WorkflowExecutionHistoryComponent } from './components/workflow-execution-history/workflow-execution-history.component';

@NgModule({
  declarations: [
    // ArgumentCardComponent,
    ConfigArgumentsCardComponent,
    ConfigExpandedComponent,
    DropdownComponent,
    DurationShowComponent,
    // TableEditableComponent,
    TableExpandableComponent,
    TableExpandableEditableComponent,
    TableNormalComponent,
    TypeSpecificStatusComponent,
    QueMngerExpandConfigComponent,
    FeatureWorkflowExpandComponent,
    TmViewWfRowComponent,
    QualityGatesFeWfComponent,
    ConfirmDialogComponent,
    StatusDirective,
    PriorityDialogComponent,
    ElevationDirective,
    GridColsDirective,
    ColumnResizeDirective,
    RunnerDetailsDialogComponent,
    ViewToolComponent,
    WorkflowRunOverviewComponent,
    CommonTableWithEditComponent,
    InputAndArgumentsComponent,
    TriggerAndArtifactComponent,
    WorkflowConfigComponent,
    I18nPipe,
    MatChipComponent,
    MatCardComponent,
    SchedulerDialogComponent,
    SchedulerComponent,
    IwAddWfComponent,
    VideoComponent,
    GuidedTourComponent,
    NoDataAvailableComponent,
    AutoCompleteDropdownComponent,
    WorkflowDetailsComponent,
    DynamicDropdownComponent,
    ProfileComponent,
    DynamicRecursiveMenuComponent,
    DateTime,
    FilterPipe,
    AutocompletePositionDirective,
    DurationFormatterPipe,
    InputArgsParentComponent,
    IssueTmplTableComponent,
    DynamicFormComponent,
    AccessDeniedComponent,
    DependencyGraphComponent,
    WorkflowExecutionHistoryComponent,
  ],
  exports: [
    DropdownComponent,
    AutoCompleteDropdownComponent,
    // TableEditableComponent,
    TableExpandableComponent,
    TableExpandableEditableComponent,
    TableNormalComponent,
    TypeSpecificStatusComponent,
    QueMngerExpandConfigComponent,
    FeatureWorkflowExpandComponent,
    TmViewWfRowComponent,
    QualityGatesFeWfComponent,
    ConfirmDialogComponent,
    StatusDirective,
    ElevationDirective,
    GridColsDirective,
    ColumnResizeDirective,
    ViewToolComponent,
    WorkflowRunOverviewComponent,
    CommonTableWithEditComponent,
    InputAndArgumentsComponent,
    TriggerAndArtifactComponent,
    WorkflowConfigComponent,
    MatChipComponent,
    MatCardComponent,
    SchedulerDialogComponent,
    SchedulerComponent,
    IwAddWfComponent,
    VideoComponent,
    I18nPipe,
    GuidedTourComponent,
    NoDataAvailableComponent,
    DateTime,
    DynamicDropdownComponent,
    FilterPipe,
    AutocompletePositionDirective,
    FormsModule,
    DurationFormatterPipe,
    InputArgsParentComponent,
    IssueTmplTableComponent,
    DynamicFormComponent,
    AccessDeniedComponent,
    DependencyGraphComponent,
    WorkflowExecutionHistoryComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    FormsModule,
    ChartsModule,
    GuidedTourModule,
    NgxGraphModule,
  ]
})
export class SharedModule { }
